import { RootState } from '../../Application';
import { Condition } from '../../screen/Condition';

export const isConfigReady = new Condition({
  check: (state: RootState) => {
    return state.Config.backendConfig ? true : false;
  },
  failMessage: 'Config has not been initialized'
});